import { NgModule } from '@angular/core';
import { BaseDeregisterCandidateModalComponent } from './_components/base-deregister-candidate-modal/base-deregister-candidate-modal.component';
import { BaseWrapperComponent } from './_components/base-wrapper/base-wrapper.component';
import { BaseHeaderComponent } from './_components/base-header/base-header.component';
import { BaseSidebarComponent } from './_components/base-sidebar/base-sidebar.component';
import { BaseUserNavComponent } from './_components/base-user-nav/base-user-nav.component';
import { BaseEmptyListRowComponent } from './_components/base-empty-list-row/base-empty-list-row.component';
import { BaseVerticalNavComponent } from './_components/base-vertical-nav/base-vertical-nav.component';
import { BasePageTitleComponent } from './_components/base-page-title/base-page-title.component';
import { BaseErrorComponent } from './_components/base-error/base-error.component';
import { BaseSharedModule } from '../shared/base-shared.module';
import { BaseAmountCircleComponent } from './_components/base-amount-circle/base-amount-circle.component';
import { BaseAvatarTeaserComponent } from './_components/base-avatar-teaser/base-avatar-teaser.component';
import { BaseHorizontalNavComponent } from './_components/base-horizontal-nav/base-horizontal-nav.component';
import { BaseInlineEditComponent } from './_components/base-inline-edit/base-inline-edit.component';
import { BaseOffersStatusComponent } from './_components/base-offers-status/base-offers-status.component';
import { BaseSortableHeadlineItemComponent } from './_components/base-sortable-headline-item/base-sortable-headline-item.component';
import { BaseNotificationsComponent } from './_components/base-notifications/base-notifications.component';
import { BaseNotificationsModalComponent } from './_components/base-notifications-modal/base-notifications-modal.component';
import { BaseDocumentUploadModalComponent } from './_components/base-document-upload-modal/base-document-upload-modal.component';
import { BaseNotificationsDropdownComponent } from './_components/base-notifications/base-notifications-dropdown/base-notifications-dropdown.component';
import { BaseSurchargesComponent } from './_components/surcharges/base-surcharges.component';
import { BaseUnbrandedWrapperComponent } from './_components/base-unbranded-wrapper/base-unbranded-wrapper.component';
import { BaseLegalDocumentLinksComponent } from './_components/base-legal-document-links/base-legal-document-links.component';
import { BaseDeleteDocumentConfirmationTemplateComponent } from './_components/base-delete-document-confirmation-template/base-delete-document-confirmation-template.component';
import { BaseDatePickerModalComponent } from './_components/base-date-picker-modal/base-date-picker-modal.component';
import { BaseGoBackTeaserComponent } from './_components/base-go-back-teaser/base-go-back-teaser.component';
import { BaseIndustrySurchargesComponent } from './_components/base-industry-surcharges/base-industry-surcharges.component';
import { BaseUserMenuSidebarComponent } from './_components/base-user-menu-sidebar/base-user-menu-sidebar.component';
import { BaseApplicationSectionsSidebarComponent } from './_components/base-application-sections-sidebar/base-application-sections-sidebar.component';
import { BaseErrorPageHeaderNavComponent } from './_components/base-error-page-header-nav/base-error-page-header-nav.component';
import { BaseNotificationListItemComponent } from './_components/base-notifications-modal/base-notification-list-item/base-notification-list-item.component';
import { BaseIzsRatingComponent } from './_components/base-izs-rating/izs-rating.component';
import { BaseDocumentBadgeComponent } from './_components/base-document-badge-list/base-document-badge/base-document-badge.component';
import { BaseDocumentBadgeListComponent } from './_components/base-document-badge-list/base-document-badge-list.component';
import { BaseAdditionalListComponent } from './_components/base-additional-list/base-additional-list.component';
import { BaseInquiryDocumentPreviewComponent } from './_components/inquiry-document-preview/inquiry-document-preview.component';
import { BaseMasterDataDocumentComponent } from './_components/base-master-data-document/base-master-data-document.component';
import { BaseRegenerateContractModalComponent } from './_components/contract/regenerate-contract-modal/base-regenerate-contract-modal.component';
import { BaseContractViewerToolbarComponent } from './_components/contract/contract-viewer-toolbar/base-contract-viewer-toolbar.component';
import { BaseContractViewerComponent } from './_components/contract/contract-viewer/base-contract-viewer.component';
import { BaseContractUploadComponent } from './_components/contract/contract-upload/base-contract-upload.component';
import { BaseCustomerContractDropdownComponent } from './_components/contract/customer-contract-dropdown/base-customer-contract-dropdown.component';
import { BaseEmployeeIdCardActionButtonsComponent } from './_components/base-employee-id-card-action-buttons/base-employee-id-card-action-buttons.component';

@NgModule({
  imports: [BaseSharedModule],
  declarations: [
    BaseWrapperComponent,
    BaseDocumentUploadModalComponent,
    BaseHeaderComponent,
    BaseSidebarComponent,
    BaseUserNavComponent,
    BaseEmptyListRowComponent,
    BaseVerticalNavComponent,
    BasePageTitleComponent,
    BaseErrorComponent,
    BaseAmountCircleComponent,
    BaseAvatarTeaserComponent,
    BaseHorizontalNavComponent,
    BaseInlineEditComponent,
    BaseOffersStatusComponent,
    BaseSortableHeadlineItemComponent,
    BaseNotificationsComponent,
    BaseNotificationsModalComponent,
    BaseNotificationsDropdownComponent,
    BaseSurchargesComponent,
    BaseUnbrandedWrapperComponent,
    BaseDeregisterCandidateModalComponent,
    BaseLegalDocumentLinksComponent,
    BaseDeleteDocumentConfirmationTemplateComponent,
    BaseDatePickerModalComponent,
    BaseGoBackTeaserComponent,
    BaseIndustrySurchargesComponent,
    BaseUserMenuSidebarComponent,
    BaseApplicationSectionsSidebarComponent,
    BaseErrorPageHeaderNavComponent,
    BaseNotificationListItemComponent,
    BaseIzsRatingComponent,
    BaseDocumentBadgeListComponent,
    BaseDocumentBadgeComponent,
    BaseAdditionalListComponent,
    BaseInquiryDocumentPreviewComponent,
    BaseMasterDataDocumentComponent,
    BaseRegenerateContractModalComponent,
    BaseContractViewerComponent,
    BaseContractViewerToolbarComponent,
    BaseCustomerContractDropdownComponent,
    BaseContractUploadComponent,
    BaseEmployeeIdCardActionButtonsComponent,
  ],
  exports: [
    BaseWrapperComponent,
    BaseDocumentUploadModalComponent,
    BaseHeaderComponent,
    BaseSidebarComponent,
    BaseUserNavComponent,
    BaseEmptyListRowComponent,
    BaseVerticalNavComponent,
    BasePageTitleComponent,
    BaseErrorComponent,
    BaseAmountCircleComponent,
    BaseAvatarTeaserComponent,
    BaseHorizontalNavComponent,
    BaseInlineEditComponent,
    BaseOffersStatusComponent,
    BaseSortableHeadlineItemComponent,
    BaseSurchargesComponent,
    BaseUnbrandedWrapperComponent,
    BaseDeregisterCandidateModalComponent,
    BaseLegalDocumentLinksComponent,
    BaseDeleteDocumentConfirmationTemplateComponent,
    BaseDatePickerModalComponent,
    BaseGoBackTeaserComponent,
    BaseIndustrySurchargesComponent,
    BaseUserMenuSidebarComponent,
    BaseApplicationSectionsSidebarComponent,
    BaseErrorPageHeaderNavComponent,
    BaseNotificationListItemComponent,
    BaseIzsRatingComponent,
    BaseDocumentBadgeListComponent,
    BaseDocumentBadgeComponent,
    BaseAdditionalListComponent,
    BaseInquiryDocumentPreviewComponent,
    BaseMasterDataDocumentComponent,
    BaseRegenerateContractModalComponent,
    BaseContractViewerComponent,
    BaseContractViewerToolbarComponent,
    BaseCustomerContractDropdownComponent,
    BaseContractUploadComponent,
    BaseEmployeeIdCardActionButtonsComponent,
  ],
})
export class AppsSharedModule {}
